"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleLogin = exports.UploadButton = exports.ButtonGhost = exports.ButtonCustom = exports.ButtonSecondary = exports.ButtonPrimary = void 0;
var react_1 = __importStar(require("react"));
var styled_1 = require("./styled");
var react_router_dom_1 = require("react-router-dom");
var lodash_1 = require("lodash");
var Typo_1 = require("../Typo");
var icons_1 = require("../../icons");
var themes_1 = require("../../themes");
var DisplayIcon = function (_a) {
    var icon = _a.icon, size = _a.size, color = _a.color, iconWeight = _a.iconWeight;
    var IconComp = icons_1.icons[icon];
    return react_1.default.createElement(react_1.default.Fragment, null, IconComp && react_1.default.createElement(IconComp, { size: size, color: color, weight: iconWeight || 'bold' }));
};
var ButtonStyledWrapper = function (_a) {
    var props = _a.props, variant = _a.variant;
    var id = props.id, link = props.link, children = props.children, value = props.value, submit = props.submit, icon = props.icon, iconAfter = props.iconAfter, onClick = props.onClick, onMouseDown = props.onMouseDown, active = props.active, disabled = props.disabled, invert = props.invert, theme = props.theme, width = props.width, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, color = props.color, style = props.style, className = props.className, S = props.S, M = props.M, iconSize = props.iconSize, _iconColor = props.iconColor, iconWeight = props.iconWeight, stopPropagation = props.stopPropagation, preventDefault = props.preventDefault, forceHover = props.forceHover;
    var displayText = (link === null || link === void 0 ? void 0 : link.displayText) || children || value;
    var debouncedOnClick = onClick && (0, lodash_1.debounce)(onClick, 200);
    var debouncedMouseDown = onMouseDown && (0, lodash_1.debounce)(onMouseDown, 150);
    var composition = (icon || iconAfter) && displayText
        ? "icon+text"
        : !displayText
            ? "iconOnly"
            : "textOnly";
    var size = ['icon+text', 'textOnly'].indexOf(composition) !== -1
        ? (S && 'S') || 'M'
        : (M && 'M') || 'S';
    var calcIconSize = function () {
        var thisSize = iconSize || size;
        return thisSize === 'S' ? 15 : 20;
    };
    var iconColor = !disabled ? _iconColor : themes_1.colors.greyColor40;
    return (react_1.default.createElement(styled_1.ButtonStyled, { id: id, style: style, className: className, variant: variant, size: size, active: active, invert: invert, disabled: disabled, theme: theme, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, type: submit ? "submit" : "button", onClick: function (e) {
            stopPropagation && e.stopPropagation();
            preventDefault && e.preventDefault();
            debouncedOnClick && debouncedOnClick(e);
        }, onMouseDown: function (e) {
            stopPropagation && e.stopPropagation();
            preventDefault && e.preventDefault();
            debouncedMouseDown && debouncedMouseDown(e);
        }, composition: composition, width: width, color: color, forceHover: forceHover },
        icon && react_1.default.createElement(DisplayIcon, { icon: icon, color: iconColor, size: calcIconSize(), iconWeight: iconWeight || '' }),
        displayText && react_1.default.createElement(Typo_1.SANS_3, { semibold: true }, displayText),
        iconAfter && react_1.default.createElement(DisplayIcon, { icon: iconAfter, color: iconColor, size: calcIconSize(), iconWeight: iconWeight || '' })));
};
/**
 * Generates a Button component based on the provided props and variant.
 *
 * @prop { ButtonProps } props - The properties for the Button component
 * @prop { string } variant - The variant of the Button component
 * @return { ReactNode } The Button component to be rendered
 */
var Button = function (_a) {
    var props = _a.props, variant = _a.variant;
    var link = props.link, onClick = props.onClick;
    var buttonAction = link ? function () { return null; } : onClick;
    return link ? (react_1.default.createElement(react_router_dom_1.Link, { to: link.val },
        react_1.default.createElement(ButtonStyledWrapper, { props: __assign(__assign({}, props), { onClick: buttonAction }), variant: variant }))) : (react_1.default.createElement(ButtonStyledWrapper, { props: __assign(__assign({}, props), { onClick: buttonAction }), variant: variant }));
};
var ButtonPrimary = function (props) { return (react_1.default.createElement(Button, { props: props, variant: "primary" })); };
exports.ButtonPrimary = ButtonPrimary;
var ButtonSecondary = function (props) { return (react_1.default.createElement(Button, { props: props, variant: "secondary" })); };
exports.ButtonSecondary = ButtonSecondary;
var ButtonCustom = function (props) { return (react_1.default.createElement(Button, { props: props, variant: "custom" })); };
exports.ButtonCustom = ButtonCustom;
var ButtonGhost = function (props) { return (react_1.default.createElement(Button, { props: props, variant: "ghost" })); };
exports.ButtonGhost = ButtonGhost;
/**
 * Renders an upload button component.
 *
 * @param {UploadButtonProps} props - The props for the upload button component.
 * @return {React.ReactNode} The rendered upload button component.
 */
var UploadButton = function (props) {
    var inputRef = (0, react_1.useRef)(null);
    var mutilple = props.mutilple, onChange = props.onChange, variant = props.variant, id = props.id, accept = props.accept;
    var handleFileUpload = function () {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", { id: id, ref: inputRef, type: "file", accept: accept, multiple: mutilple, onChange: onChange, style: { display: "none" } }),
        react_1.default.createElement(ButtonStyledWrapper, { props: __assign(__assign({}, props), { onClick: handleFileUpload }), variant: variant || "secondary" })));
};
exports.UploadButton = UploadButton;
/**
 * Renders a Google login button component.
 *
 * @props - The props for the Google login button component.
 * @prop {string} props.theme - The theme for the button.
 * @prop {string} props.S - The size of the button.
 * @prop {boolean} props.disabled - Whether the button is disabled or not.
 * @prop {string} props.width - The width of the button.
 * @prop {string} props.className - The class name of the button.
 * @prop {React.CSSProperties} props.style - The inline style of the button.
 * @prop {string} props.value - The value of the button.
 * @prop {React.ReactNode} props.children - The children of the button.
 * @prop {Function} props.onClick - The click event handler for the button.
 * @return {React.ReactNode} The rendered Google login button component.
 */
var GoogleLogin = function (props) {
    var theme = props.theme, S = props.S, disabled = props.disabled, width = props.width, className = props.className, style = props.style, value = props.value, children = props.children, onClick = props.onClick;
    var displayText = value || children || "Sign up with Google";
    var size = (S && "S") || "M";
    return (react_1.default.createElement(styled_1.ButtonStyled, { size: size, disabled: disabled, width: width, onClick: onClick, variant: "googleAuth", theme: theme, style: style, className: className },
        react_1.default.createElement(DisplayIcon, { icon: "OkeGoogleIcon", size: 24 }),
        displayText && react_1.default.createElement(Typo_1.SANS_3, { semibold: true }, displayText)));
};
exports.GoogleLogin = GoogleLogin;
